module.exports = __webpack_public_path__ + "static/media/Pending_Receive.b66a5b16.svg";